module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0010.jpg?v=911ca876";